import { render, staticRenderFns } from "./BeCalmCourse.vue?vue&type=template&id=0a9a069a"
import script from "./BeCalmCourse.vue?vue&type=script&lang=js"
export * from "./BeCalmCourse.vue?vue&type=script&lang=js"
import style0 from "./BeCalmCourse.vue?vue&type=style&index=0&id=0a9a069a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports